import { render, staticRenderFns } from "./ModelHouseIndex.vue?vue&type=template&id=6a87ce64&scoped=true&"
import script from "./ModelHouseIndex.vue?vue&type=script&lang=js&"
export * from "./ModelHouseIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a87ce64",
  null
  
)

export default component.exports